import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const Login = createAsyncThunk(
  "UserLogin",
  async (arg, { rejectWithValue }) => {
    try {
      console.log(`-------BASE_URL ---------`, BASE_URL);
      const response = await axios.post(`${BASE_URL}/api/v1/User/login`, arg);
      console.log("Response from API:", response);

      const userData = response.data.data;
      console.log("User Data:---->>>>>>>>", userData.user.role); // Log userData to verify its structure

      const userId = userData.user.id; // Assuming the user ID is stored as userData.user.id

      // const role = userData.user.role;
      // console.log("role---->:", role);

      // if (role === "ADMIN") {
      //   return userData;
      // }

      const token = userData.access_token;
      if (token) {
        secureLocalStorage.setItem("token", token);
        localStorage.setItem("token", token);

        secureLocalStorage.setItem("userId", userId); // Secure storage for sensitive data
        localStorage.setItem("userId", userId); // Regular storage

        secureLocalStorage.setItem("user", JSON.stringify(userData));
        const decoded = jwtDecode(token);
        toast.success("Login successful", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });

        return userData; // Return the entire data object to access role in the reducer
      } else {
        console.error("No access token found in the response");
        return rejectWithValue("No access token found in the response");
      }
    } catch (error) {
      toast.error("Login failed", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
      });
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const verifyOTP = createAsyncThunk(
  "verifyOTP",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/verify-OTP-Authentication`,
        arg
      );
      console.log("response", response);
      toast.success("Proceed to login and access our services. Use our budget planning tool and select your dedicated event coordinator, as shown in the video.", toast_config);
      return response;
    } catch (error) {
      console.log("response", error);
      toast.error(" failed", toast_config);
      return rejectWithValue(error.message);
    }
  }
);

export const forgotPassword = createAsyncThunk(
  "forgotPassword",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/forgot-Password`,
        arg
      );
      toast.success(
        "OTP sent successfully. Please check your email.",
        toast_config
      );
      return response;
    } catch (error) {
      toast.error("OTP sent failed", toast_config);
      return rejectWithValue(error.message);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/reset-Password`,
        arg
      );
      toast.success("Password Change  successfully.", toast_config);
      return response;
    } catch (error) {
      toast.error("Password Change  failed", toast_config);
      return rejectWithValue(error.message);
    }
  }
);

export const verifyOTPAndRegister = createAsyncThunk(
  "verifyOTPAndRegister",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/User/verifyOTP`,
        arg
      );
      toast.success("  successfully.", toast_config);
      return response;
    } catch (error) {
      toast.error(" failed", toast_config);
      return rejectWithValue(error.message);
    }
  }
);

const loginSlice = createSlice({
  name: "loginSlice",
  initialState: {
    commentData: [],
    IsAdding: false,
    loading: false,
    error: null,
    role: null,
    userDetails: null,
  },
  reducers: {
    IsAddingOpen: (state, action) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state, action) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Login.pending, (state) => {
        state.loading = true;
      })
      .addCase(Login.fulfilled, (state, action) => {
        state.loading = false;
        // state.role = action.payload.Role;
        state.role = action.payload?.user?.role;
        state.userDetails = action.payload?.user;

        const event = new Event("userDetailsUpdated");
        window.dispatchEvent(event);
      })

      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(verifyOTPAndRegister.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOTPAndRegister.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(verifyOTP.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addMatcher(
        (action) =>
          action.type.endsWith("/rejected") && action.meta.rejectedWithValue,
        (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
        }
      );
  },
});

export const { IsAddingOpen } = loginSlice.actions;
export default loginSlice.reducer;
